import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { BSModal, MessageBox } from "../../../common";

import ImportMembersForm from "./ImportMembersForm";
import FORMATS, { AETELUQ, AGECRO_CONTINUING_EDUCATION, AGECRO_ONLINE_EDUCATION, AGECRO_REGULAR_EDUCATION } from "./enums/importMemberFormats";

import { formValueSelector } from "redux-form";
import { ADMINISTRATOR, DIRECTOR, FINTECH, MANAGER } from "../../../../utils/Roles";
import * as types from "../../../../utils/data/dataActionTypes";
import * as dataActions from "../../../../utils/data/dataActions";
import {
  BILLING_PERIODS,
  CLASSES,
  CLIENTS,
  CLIENTS_GRAPHQL,
  CLIENT_COVERAGES,
  DIVISIONS,
} from "../../../../utils/data/models";
import userHasAccess from "../../../../utils/userHasAccess";
import { arrayToFilterStr, buildGraphQLQueryParams } from "../../../common/GraphQL/GraphQLQueryHelper";
import { getRetroactiveLimitDate } from "../../../common/RetroactiveData/RetroactiveLimitHelper";
import { isClientInTransition } from "../../../common/RouteValidators/ClientValidationHelper";
import { LIST_API_HOOK_ERRORS } from "../../../common/enums/apiHooksErrorType";
import { MANUAL } from "../../clients/enums/billingPeriodTypes";
import { PM } from "../../clients/enums/businessAccountTypes";
import AGECRO_SESSIONS_TYPE from "../../clients/enums/agecroSessionTypes";

class ImportMembersPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      response: {},
      showConfirmationModal: false,
      confirmationMessage: "",
      confirmationActions: [],
      clientInTransition: false,
      APIHookErrorValue: "",
      maximumRetroactiveDate: undefined,
      fetchingMaximumRetroactiveDate: true
    };

    this.getGraphQLQuery = this.getGraphQLQuery.bind(this);
    this.closeConfirmation = this.closeConfirmation.bind(this);
    this.handleClientChange = this.handleClientChange.bind(this);
    this.importMemberList = this.importMemberList.bind(this);
    this.validated = this.validated.bind(this);
    this.refetchIsTransition = this.refetchIsTransition.bind(this);
    this.setmaximumRetroactiveDate = this.setmaximumRetroactiveDate.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(BILLING_PERIODS);
    let filters = [CLIENTS_GRAPHQL.archiveFilter, CLIENTS_GRAPHQL.currentClientsFilter];
    if (!userHasAccess([DIRECTOR, MANAGER, ADMINISTRATOR, FINTECH], true)) {
      filters.push(CLIENTS_GRAPHQL.nonMEVClientsFilter);
    }
    filters = arrayToFilterStr(filters);
    const sort = [CLIENTS_GRAPHQL.defaultSort];
    const graphQLQuery = this.getGraphQLQuery(
      filters,
      sort,
      0,
      0,
      "getClients",
      ""
    );
    this.props.dataActions.getGraphQL(
      CLIENTS_GRAPHQL,
      { query: graphQLQuery },
      sort
    );
  }

  componentWillUnmount() {
    this.props.dataActions.clearDataList(BILLING_PERIODS);
    this.props.dataActions.clearDataList(CLIENT_COVERAGES);
    this.props.dataActions.clearDataList(DIVISIONS);
    this.props.dataActions.clearDataList(CLASSES);
  }

  setmaximumRetroactiveDate(clientId) {
    getRetroactiveLimitDate(clientId, (result) => {
      this.setState({
        maximumRetroactiveDate: result,
        fetchingMaximumRetroactiveDate: false
      });
    });

  }

  getGraphQLQuery(filter, sortBy, offset, limit, queryName, q) {
    const colsStr = `
	clientId
	name
	clientBillingPeriodType
	designator
	isAutomaticMemberIdentifier
	clientNumber
	clientStatusType
	lastActiveDate
	businessAccountType
	`;
    return buildGraphQLQueryParams(
      "clients",
      filter,
      sortBy,
      offset,
      limit,
      colsStr,
      queryName,
      q
    );
  }

  closeConfirmation() {
    this.setState({ showConfirmationModal: false });
  }

  generateConfirmationMessage(values) {
    const { billingPeriodId, clientId, fileFormat, file, classId, importSessionPeriod } = values;
    const client = this.props.clients.find(
      (item) => item.clientId.toString() === clientId.toString()
    );
    let classToDisplay = undefined;

    if (client.clientBillingPeriodType == MANUAL.value && client.businessAccountType == PM.value) {
      classToDisplay = this.props.classes.find(
        (item) => item.classId.toString() === classId.toString()
      ).name;

    }
    const billingPeriod = this.props.billingPeriods.find(
      (item) => item.billingPeriodId.toString() === billingPeriodId.toString()
    );
    const formatKey = FORMATS.find((item) => item.value === fileFormat).key;
    const sessionKey = importSessionPeriod ? AGECRO_SESSIONS_TYPE.find((item) => item.value === Number(importSessionPeriod)).key : null;
    const fileName = [AETELUQ.key, AGECRO_CONTINUING_EDUCATION.key, AGECRO_ONLINE_EDUCATION.key, AGECRO_REGULAR_EDUCATION.key].includes(formatKey) ? null : file[0].name;
    return (
      <div className="formatted-confirmation">
        <p>
          <FormattedMessage id="importExport.importMembers.confirmation.message" />
        </p>
        <p>
          <FormattedMessage
            id="importExport.importMembers.form.client"
            tagName="strong"
          />
          <span>{client.name}</span>
        </p>
        <p>
          <FormattedMessage
            id="importExport.importMembers.form.billingPeriod"
            tagName="strong"
          />
          <span>
            {billingPeriod.localizations[this.props.authLanguageCode].name}
          </span>
        </p>
        <p>
          <FormattedMessage
            id="importExport.importMembers.form.format"
            tagName="strong"
          />
          <FormattedMessage id={formatKey} />
        </p>
        {fileName && (
          <p>
            <FormattedMessage
              tagName="strong"
              id="importExport.importMembers.confirmation.fileName"
            />
            <span>{fileName}</span>
          </p>
        )}
        {classToDisplay && (
          <p>
            <FormattedMessage
              tagName="strong"
              id="importExport.importMembers.confirmation.class"
            />
            <span>{classToDisplay}</span>
          </p>
        )}
        {sessionKey && (
          <p>
            <FormattedMessage
              tagName="strong"
              id="importExport.importMembers.form.importSessionPeriod"
            />
            <span>
              <FormattedMessage id={sessionKey} />
            </span>
          </p>
        )}
        {(client.clientBillingPeriodType == MANUAL.value) && ( 
          <MessageBox key="classWarning" className="alert-info">
            <FormattedMessage id="importExport.importMembers.confirmation.classWarning" />
          </MessageBox>
        )}
      </div>
    );
  }

  generateConfirmationTitle() {
    return (
      <FormattedMessage id="importExport.importMembers.confirmation.title">
        {(m) => <span className="icon warning">{m}</span>}
      </FormattedMessage>
    );
  }

  importMemberList(values) {
    this.setState({ APIHookErrorValue: "" });
    let model = {
      ...CLIENTS,
      path: CLIENTS.path + `/${values.clientId}/import`,
    };
    let formData = new FormData();

    let query = {};

    Object.keys(values).map((key) => {
      if (key == "file") {
        formData.append(key, values[key][0]);
      } else {
        query[key] = values[key];
      }
    });

    return this.props.dataActions
      .createDataItem(model, formData, {}, { contentType: "formData" }, query)
      .then((results) => {
        if (results.type == types.CREATE_DATA_ITEM_FAILURE && LIST_API_HOOK_ERRORS.includes(results.payload.error.data.message)) {
          this.setState({ APIHookErrorValue: results.payload.error.data.message });
        }
        else {
          this.setState({ response: results.payload });
        }
      });
  }

  handleClientChange(event) {
    this.setState({ APIHookErrorValue: "", fetchingMaximumRetroactiveDate: true });
    const clientId = event.target.value;
    if (clientId == " ") {
      this.props.dataActions.clearDataList(BILLING_PERIODS);
      this.props.dataActions.clearDataList(CLASSES);
      this.props.dataActions.clearDataList(CLIENT_COVERAGES);
      this.props.dataActions.clearDataList(DIVISIONS);
      return;
    }
    this.setmaximumRetroactiveDate(clientId);
    this.props.dataActions.getDataList(
      CLASSES,
      0,
      0,
      "",
      ["classId:asc"],
      [CLASSES.archiveFilter, "classes.clientId==" + clientId],
      {},
      {},
      "*"
    );
    this.props.dataActions.getDataList(
      DIVISIONS,
      0,
      1,
      "",
      ["divisionId:asc"],
      [DIVISIONS.archiveFilter, "divisions.clientId==" + clientId],
      {},
      {},
      "divisionId"
    );
    this.props.dataActions.getDataList(
      CLIENT_COVERAGES,
      0,
      1,
      "",
      ["clientCoverageId:asc"],
      [CLIENT_COVERAGES.archiveFilter, "clientCoverages.clientId==" + clientId],
      {},
      {},
      "clientCoverageId"
    );
    this.props.dataActions.getDataList(
      BILLING_PERIODS,
      0,
      0,
      "",
      ["startDate:desc"],
      ["billingPeriods.clientId==" + clientId],
      {},
      {},
      "billingPeriodId,startDate,endDate,localizations"
    );


    isClientInTransition(clientId).then((res) => {
      this.setState({ clientInTransition: res });
    });
  }

  refetchIsTransition() {
    if (this.props.clientId) {
      isClientInTransition(this.props.clientId).then((res) => {
        this.setState({ clientInTransition: res });
      });
    }
  }

  validated(values) {
    this.setState({
      ...this.state,
      showConfirmationModal: true,
      confirmationMessage: this.generateConfirmationMessage(values),
      confirmationActions: [
        {
          id: 1,
          text: <FormattedMessage id="common.confirm" />,
          action: () => {
            this.importMemberList(values);
            this.closeConfirmation();
          },
        },
      ],
    });
  }

  render() {
    return (
      <div className="sub-content">
        {this.state.APIHookErrorValue && (
          <MessageBox className="alert-danger">
            <FormattedMessage id={this.state.APIHookErrorValue} />
          </MessageBox>
        )}
        <ImportMembersForm
          ref="form"
          allLoaded={this.props.allLoaded}
          billingPeriods={this.props.billingPeriods}
          noClasses={this.props.noClasses}
          noCoverages={this.props.noCoverages}
          noDivisions={this.props.noDivisions}
          clients={this.props.clients}
          classes={this.props.classes}
          handleClientChange={this.handleClientChange}
          importing={this.props.importing}
          onSubmit={this.validated}
          response={this.state.response}
          clientInTransition={this.state.clientInTransition}
          refetchIsTransition={this.refetchIsTransition}
          maximumRetroactiveDate={this.state.maximumRetroactiveDate}
          fetchingMaximumRetroactiveDate={this.state.fetchingMaximumRetroactiveDate}
          sessions={AGECRO_SESSIONS_TYPE}
        />

        <BSModal
          show={this.state.showConfirmationModal}
          title={this.generateConfirmationTitle()}
          actions={this.state.confirmationActions}
          onClose={this.closeConfirmation}
        >
          {this.state.confirmationMessage}
        </BSModal>
      </div>
    );
  }
}

ImportMembersPage.propTypes = {
  allLoaded: PropTypes.bool,
  billingPeriods: PropTypes.array,
  clients: PropTypes.array,
  dataActions: PropTypes.object,
  importing: PropTypes.bool,
  authLanguageCode: PropTypes.string,
  noClasses: PropTypes.bool.isRequired,
  noCoverages: PropTypes.bool.isRequired,
  noDivisions: PropTypes.bool.isRequired,
  clientId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  classes: PropTypes.array,
};

function mapStateToProps(state) {
  const billingPeriods = state.data.billingPeriods || {};
  const classes = state.data.classes || {};
  const clientCoverages = state.data.clientCoverages || {};
  const clients = state.data.clients || {};
  const divisions = state.data.divisions || {};
  const importMembersSelector = formValueSelector("importMembersForm");

  return {
    allLoaded:
      (billingPeriods.fetched &&
        classes.fetched &&
        clientCoverages.fetched &&
        divisions.fetched) ||
      false,
    billingPeriods: billingPeriods.items || [],
    classes: classes.items || [],
    clients: clients.items || [],
    importing: state.data.submitting,
    noClasses: !(classes.items || []).length,
    noCoverages: !(clientCoverages.items || []).length,
    noDivisions: !(divisions.items || []).length,
    authLanguageCode: state.auth.user.languageCode,
    clientId: importMembersSelector(state, "clientId")
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportMembersPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/importMembers/ImportMembersPage.js